import moment from 'moment-timezone'

/*
 * @author          Parimal A Ghadiyali
 * @date            09th January 2018
 * @type            Survey preview store File
 * @description -   This file has methods to retrieve and all survey settings, survey design and questions of a survey
 *
 */
import { queTypeConfig, queValidationConfig, encrypted_key, encrypted_iv, searchLastResponseDate } from '@config'
import CryptoJS from 'crypto-js'
import { normalizeSurveyDesignDetails } from '@/utils/previewTheme'
function initialState () {
  return {
    surveyMasterDetails: [],
    surveyDesignDetails: null,
    surveyQuestionDetails: [],
    surveyResponseDate: [],
    surveyResponseDetailIds : [],
    defautchkMapMulChoice: [],
    defautSetTime: [],
    surveyOriginalQuestionDetails: [],
    surveyStartEndQuestions: [],
    surveyAllFlagDetails: {},
    relationships: {},
    query: {},
    cancelSource: null,
    loading: false,
    addResponseStatus: {},
    surveyResponseDetails: [],
    oldResponseAnswer: [],
    tempPreviouslySelectedRating: {},
    allSurveyAnswersDetails: [],
    chkOtherMultipleChoice: [],
    signatureQuestionsDetails: {},
    storeAllPhotoQuestion: {},
    showAllSignatureQuestion: {},
    showAllPhotoQuestion: {},
    allAddressQuestions: {},
    searchResponse: false,
  }
}
const getters = {
  surveyMasterDetails: state => {
    let rows = state.surveyMasterDetails
    return rows
  },
  surveyDesignDetails: state => {
    let rows = state.surveyDesignDetails
    return rows
  },
  surveyQuestionDetails: state => {
    let rows = state.surveyQuestionDetails
    return rows
  },
  surveyResponseDate: state => {
    let rows = state.surveyResponseDate
    return rows
  },
  surveyResponseDetailIds: state => {
    let rows = state.surveyResponseDetailIds
    return rows
  },
  oldResponseAnswer:  state => {
    let rows = state.oldResponseAnswer
    return rows
  },
  tempPreviouslySelectedRating: state => {
    let rows = state.tempPreviouslySelectedRating
    return rows
  },
  defautchkMapMulChoice: state => {
    let rows = state.defautchkMapMulChoice
    return rows
  },
  defautSetTime: state => {
    let rows = state.defautSetTime
    return rows
  },
  surveyOriginalQuestionDetails: state => {
    let rows = state.surveyOriginalQuestionDetails
    return rows
  },
  surveyStartEndQuestions: state => {
    let rows = state.surveyStartEndQuestions
    return rows
  },
  surveyAllFlagDetails: state => {
    let rows = state.surveyAllFlagDetails
    return rows
  },
  addResponseStatus: state => {
    let rows = state.addResponseStatus
    return rows
  },
  editResponseStatus: state => {
    let rows = state.editResponseStatus
    return rows
  },
  surveyResponseDetails: state => {
    let rows = state.surveyResponseDetails
    return rows
  },
  allSurveyAnswersDetails:  state => {
    let rows = state.allSurveyAnswersDetails
    return rows
  },
  chkOtherMultipleChoice:  state => {
    let rows = state.chkOtherMultipleChoice
    return rows
  },
  signatureQuestionsDetails:  state => {
    let rows = state.signatureQuestionsDetails
    return rows
  },
  storeAllPhotoQuestion: state => {
    let rows = state.storeAllPhotoQuestion
    return rows
  },
  showAllSignatureQuestion: state => {
    let rows = state.showAllSignatureQuestion
    return rows
  },
  showAllPhotoQuestion: state => {
    let rows = state.showAllPhotoQuestion
    return rows
  },
  allAddressQuestions: state => {
    let rows = state.allAddressQuestions
    return rows
  },
  searchResponse: state => {
    let rows = state.searchResponse
    return rows
  },
  total: state => state.length,
  loading: state => state.loading,
  relationships: state => state.relationships
}
const actions = {
  // get data for edit question
  async getFullSurveyDetailsBySurveyId ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getFullSurveyDetailsBySurveyId';
      await axios
        .post(
          url,
          {
            responseType: 'json',
            lang: surveyData['lang'],
            in_survey_Id: surveyData['in_survey_Id'],
            request_id: surveyData['requestId'],
            in_is_login_required: surveyData['in_is_login_required']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setSurveyOriginalQuestionDetails', response.data.data[0]['survey_question_detail'])
            commit('setAllSurveyDetails', response.data.data[0])

          } else {
            commit('setAllSurveyDetails', response.data.msg)
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  async getFullOnlineSurveyDetailsBySurveyId ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getFullOnlineSurveyDetailsBySurveyId';
      await axios
        .post(
          url,
          {
            responseType: 'json',
            lang: surveyData['lang'],
            in_survey_Id: surveyData['in_survey_Id'],
            request_id: surveyData['requestId'],
            in_is_login_required: surveyData['in_is_login_required']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag == 1) {
            commit('setSurveyOriginalQuestionDetails', response.data.data[0]['survey_question_detail'])
            commit('setAllSurveyDetails', response.data.data[0])
          } else if (response.data.flag == 4) {
            alert(response.data.msg)
            window.location.href = location.protocol + '//' + location.host
          } else {
            alert(response.data.msg)
            window.location.href = location.protocol + '//' + location.host
            commit('setAllSurveyDetails', response.data.msg)
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  async getFullSurveyDesignById ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url =
      process.env.API_PATH +
      '/getFullSurveyDesignById/' +
      sessionData['in_survey_Id']
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          in_survey_Id: sessionData['in_survey_Id'],
          in_survey_Id_normal: sessionData['in_survey_Id_normal'],
          request_id: sessionData['requestId'],
          isPreview: sessionData['request_type']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAllDesign', response.data.data[0])
        // commit('setFlagMsg',response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // get data for start end screen of survey
  async getSurveyStartEndData ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getStartEndScreenBySurveyId';
      await axios
        .post(
          url,
          {
            responseType: 'json',
            lang: surveyData['lang'],
            request_id: surveyData['requestId'],
            in_survey_Id: surveyData['in_survey_Id'],
            isPreview: surveyData['request_type']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag && response.data.data) {
            commit('setsurveyStartEndQuestions', response.data.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  async addResponse ({ commit, state }, sessionData) {
    commit('setLoading', true)
    let result = null
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url = process.env.API_PATH + '/newAddResponse';
    var langData = (sessionData["lang"]) ? sessionData["lang"] : '';
    var propertyData = (sessionData["propertyname"]) ? sessionData["propertyname"] : '';
    var requestIdData = (sessionData["requestId"]) ? sessionData["requestId"] : '';
    let requestData = '{"_parts":[["responseType","json"], ["lang", "' + langData + '"], ["in_survey_Id", "' + sessionData["in_survey_Id"] + '"], ["request_id", "' + requestIdData + '"], ["propertyname", "' + propertyData + '"], ["responseData", ' + JSON.stringify(sessionData['responseData']) + '], ["questionSentCount", "' + sessionData["questionSentCount"] + '"], ["sentDate", "' + sessionData["sentDate"] + '"], ["sentDateTimezone", "' + sessionData["sentDateTimezone"] + '"], ["collectedDate", "' + sessionData["collectedDate"] + '"], ["collectedDateTimezone", "' + sessionData["collectedDateTimezone"] + '"]]}';
    const key = CryptoJS.enc.Hex.parse(encrypted_key);
    const ivs = CryptoJS.lib.WordArray.random(16);
    var encrypted = CryptoJS.AES.encrypt(requestData, key, {
        iv: ivs,
        padding: CryptoJS.pad.ZeroPadding,
    });
    var response_data = encrypted.toString();
    const formData = new FormData();
    formData.append('request_data', JSON.stringify(response_data));
    formData.append('v', encrypted.iv.toString());

    for (const property in sessionData['49d22884af3ece2c46ba430268844fba']) {
        const file = sessionData['49d22884af3ece2c46ba430268844fba'][property];
        formData.append('49d22884af3ece2c46ba430268844fba[]', file);
    }

    await axios
      .post(
        url,        
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      .then(response => {
        var encryptedResponse = response.data.response_data;
        var resIv = CryptoJS.enc.Hex.parse(response.data.v);
        var decrypted = CryptoJS.AES.decrypt(encryptedResponse, key, {
          iv : resIv,
          padding: CryptoJS.pad.ZeroPadding,
        });
        var response_datas = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
        response.data = response_datas;
        commit('setAddResponseStatus', response.data)
        result = response
      })
      .catch(error => {
          result = error
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
      return result
  },
  async getSurveyResponseDetailsById ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url =
      process.env.API_PATH +
      '/getSurveyResponseDetailsById'
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          in_survey_Id: sessionData['in_survey_Id'],
          in_response_id: sessionData['in_response_id'],
          in_survey_Id_normal: sessionData['in_survey_Id_normal'],
          request_id: sessionData['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setSurveyResponseDetails', response.data)
      })
      .catch(error => {
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  async getAllSurveyQuestion ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url =
      process.env.API_PATH +
      '/getAllSurveyQuestion'
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          in_survey_Id: sessionData['in_survey_Id'],
          in_response_id: sessionData['in_response_id'],
          in_survey_Id_normal: sessionData['in_survey_Id_normal'],
          request_id: sessionData['requestId'],
          isPreview: sessionData['request_type']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAllSurveyAnswersDetails', response.data.data)
      })
      .catch(error => {
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  async editResponse ({ commit, state }, sessionData) {
    commit('setLoading', true)
    let result = null
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url = process.env.API_PATH + '/editResponse';

    let formData = new FormData();
    formData.append('responseType', 'json');
    formData.append('lang', sessionData['lang']);
    formData.append('in_survey_Id', sessionData['in_survey_Id']);
    formData.append('in_response_id', sessionData['in_response_id']);
    formData.append('request_id', sessionData['requestId']);
    formData.append('propertyname', sessionData['propertyname']);
    formData.append('responseData', sessionData['responseData']);
    for (const property in sessionData['imageArray']) {
      formData.append('imageArray[' + property + ']', sessionData['imageArray'][property]);
    }
    await axios
      .post(
        url,
        // {
        //   responseType: 'json',
        //   lang: sessionData['lang'],
        //   in_survey_Id: sessionData['in_survey_Id'],
        //   in_response_id: sessionData['in_response_id'],
        //   request_id: sessionData['requestId'],
        //   propertyname: sessionData['propertyname'],
        //   responseData: sessionData['responseData'],
        //   imageArray: sessionData['imageArray'],
        // },
        formData,
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setEditResponseStatus', response.data)
        result = response
      })
      .catch(error => {
          result = error
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
      return result
  },
  async searchResponseBySurveyId ({ commit, state }, sessionData) {
    commit('setLoading', true)
    let result = null
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url = process.env.API_PATH + '/searchResponseBySurveyId';
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          in_survey_Id: sessionData['in_survey_Id'],
          request_id: sessionData['requestId'],
          propertyname: sessionData['propertyname'],
          responseData: sessionData['search_text']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setSearchResponseStatus', response.data)
        result = response
      })
      .catch(error => {
          result = error
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
      return result
  },
  setQuery ({ commit }, value) {
    commit('setQuery', purify(value))
  },
  resetState ({ commit }) {
    commit('resetState')
  }
}
const mutations = {
  setAllSurveyDetails (state, items) {
    console.log('surveyMasterDetails called')
    let totalRequiredQues = 0
    state.surveyAllFlagDetails = {
      in_date: [],
      in_address: [],
      in_photo: [],
      in_media: [],
      in_audit: [],
      in_email_sent: [],
      in_date_format: {}
    }

    var groupNo = 1,
      displayFlag = 1,
      isExecuteDisplayFlag = true, questionIds = []
    items['survey_question_detail'].forEach((value, key) => {
      console.log('item key on start', key)
        questionIds[key] = value.in_question_master_id
      // It used for identifying which question has enabled address/audit/date/image
      switch (value.in_question_type_id) {
        case 1: // Text question type
          if (value.in_address == 1) {
            state.surveyAllFlagDetails['in_address'].push(
              value.in_question_master_id
            )
          }
          break
        // case 3: // List question type
        //   if (value.in_address == 1)
        //     state.surveyAllFlagDetails["in_address"].push(
        //       value.in_question_master_id
        //     );
        //   break;
        case 4: // Two choice question type - Yes/No
        case 11: // Two choice question type - True/False
        case 12: // Two choice question type - Other
          break
        case 18: //photo question type
          state.surveyAllFlagDetails['in_photo'].push(
            value.in_question_master_id
          )
          break
        case 19: // Rating question type - Satisfaction/Face Rating
        case 20: // Rating question type - Star Rating
          if (items.in_audit == 1 && value.in_audit == 1) {
            state.surveyAllFlagDetails['in_audit'].push(
              value.in_question_master_id
            )
          }
          break
        case 3: // List question type
        case queTypeConfig.TYPE_DYNAMIC_LIST: // Dynamic List question type
        case 5: // Multiple choice question type - Text
          if (items.in_audit == 1 && value.in_audit == 1) {
            state.surveyAllFlagDetails['in_audit'].push(
              value.in_question_master_id
            )
          }
          if (value.in_address == 1) {
            state.surveyAllFlagDetails['in_address'].push(
              value.in_question_master_id
            )
          }
          break
        case 13: // Multiple choice question type - Image
          if (items.in_audit == 1 && value.in_audit == 1) {
            state.surveyAllFlagDetails['in_audit'].push(
              value.in_question_master_id
            )
          }
          state.surveyAllFlagDetails['in_photo'].push(
            value.in_question_master_id
          )
          break;
        case 9: // Date question type
          state.surveyAllFlagDetails['in_date'].push(
            value.in_question_master_id
          )
          break;
        default:
          break
      }
      let tempValidation = value['question_validation_details']
      delete value['question_validation_details']
      let tempSkipLogic = value['skip_logic_master_details']
      // delete value['skip_logic_rule_details']
      // All question at a time
      console.log('1  key ', key)
      if (items.in_question_flow == 1) {
        let tmp = []
        let tmpScore = []
        state.surveyQuestionDetails[key] = {}
        state.surveyQuestionDetails[key]['queDetails'] = value
        state.surveyQuestionDetails[key]['validationDetailsObj'] = {}
        tempValidation.forEach((val, k) => {
          console.log('tempValidation k', k, key)
          if (val.question_answer_details.length > 0) {
            if (
              val.in_question_validation_id ==
                queValidationConfig.VALIDATION_MANDATORY_QUE &&
              val.question_answer_details[0].st_answer_text == 1 &&
              value.in_question_type_id != queTypeConfig.TYPE_CAMERA &&
              value.in_question_type_id !=
                queTypeConfig.TYPE_QR_AND_BARCODE_READER
            ) {
              totalRequiredQues++
            }
            var patt = '';
            // For allowed characters => Text serial number and number telephone
            if (
              val.in_question_validation_id == queTypeConfig.TYPE_12_HOURS ||
              val.in_question_validation_id ==
                queTypeConfig.TYPE_END_SCREEN_IMAGE
            ) {
              console.log('in tempLogic 1 if')
              var patt = val.question_answer_details[0].st_regex_value
              console.log('patt', patt)
              try{
                var rx = new RegExp(patt, 'g')
                console.log('rx 1', rx)
                state.surveyQuestionDetails[key].validationDetailsObj[
                  val.in_question_validation_id
                ] = rx
              }catch(err){
                console.log('try catch err', err)
              }

              console.log('rx', rx)
            } else {
              console.log('in tempLogic 1 else')
              // For terms & Conditions and multiple choices image
              if (
                (value.in_question_type_id ==
                  queTypeConfig.TYPE_MULTIPLE_TEXT &&
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS) ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_TEXT
              ) {
                console.log('in tempLogic 1 else 1 if')
                if (
                  !state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ]
                ) {
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ] = []
                }
                state.surveyQuestionDetails[key].validationDetailsObj[
                  val.in_question_validation_id
                ].push({
                  answer: val.question_answer_details[0].st_answer_text,
                  lat: val.question_answer_details[0].st_latitude
                    ? val.question_answer_details[0].st_latitude
                    : '',
                  lng: val.question_answer_details[0].st_longitude
                    ? val.question_answer_details[0].st_longitude
                    : '',
                  score:
                    items.in_audit == 1 && value.in_audit == 1
                      ? val.question_answer_details[0].st_answer_score
                      : ''
                })
              } else if (
                val.in_question_validation_id ==
                queValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS
              ) {
                console.log('in tempLogic 1 else 2 else if')
                if (
                  !state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ]
                ) {
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ] = []
                }
                state.surveyQuestionDetails[key].validationDetailsObj[
                  val.in_question_validation_id
                ].push(val.question_answer_details[0].st_answer_text)
              } else if (
                (value.in_question_type_id ==
                  queTypeConfig.TYPE_MULTIPLE_IMAGE &&
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS) ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_IMAGE
              ) {
                console.log('in tempLogic 1 else 3 else if')
                // st_answer_label
                if (
                  !state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ]
                ) {
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ] = []
                }
                state.surveyQuestionDetails[key].validationDetailsObj[
                  val.in_question_validation_id
                ].push({
                  score:
                    items.in_audit == 1 && value.in_audit == 1
                      ? val.question_answer_details[0].st_answer_score
                      : '',
                  st_answer_label:
                    val.question_answer_details[0].st_answer_label,
                  dataURL:
                    JSON.parse(val.question_answer_details[0].st_answer_text)
                      .dataURL || '',
                  s3ImagePath:
                    JSON.parse(val.question_answer_details[0].st_answer_text)
                      .s3ImagePath || ''
                })
              } else if (
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SINGLE_LINE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_STAR_RATING ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_FACE_RATING ||
                ((value.in_question_type_id == queTypeConfig.TYPE_LIST || value.in_question_type_id == queTypeConfig.TYPE_DYNAMIC_LIST) &&
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS)
              ) {
                console.log('in tempLogic 1 else 3 else if')
                if (
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS &&
                  (value.in_question_type_id == queTypeConfig.TYPE_LIST || value.in_question_type_id == queTypeConfig.TYPE_DYNAMIC_LIST)
                ) {
                  state.surveyQuestionDetails[key].validationDetailsObj[6] +=
                    '\nOther';
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ]['lat'] += val.question_answer_details[0].st_latitude
                    ? '\n' + val.question_answer_details[0].st_latitude
                    : '';
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ]['lng'] += val.question_answer_details[0].st_longitude
                    ? '\n' + val.question_answer_details[0].st_longitude
                    : '';
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ]['score'] +=
                    items.in_audit == 1 && value.in_audit == 1
                      ? '\n' + val.question_answer_details[0].st_answer_score
                      : '';
                } else {
                  // For Text question type - Single line, Rating question type - Satisfaction and Star
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ] = {
                    lat: val.question_answer_details[0].st_latitude
                      ? val.question_answer_details[0].st_latitude
                      : '',
                    lng: val.question_answer_details[0].st_longitude
                      ? val.question_answer_details[0].st_longitude
                      : '',
                    score:
                      items.in_audit == 1 && value.in_audit == 1
                        ? val.question_answer_details[0].st_answer_score
                        : ''
                  }
                }
                if (
                  val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_FACE_RATING
                ) {
                  // For converting our emoji into BAD to GOOD
                  let emojiValues = val.question_answer_details[0].st_answer_text.split(
                    'sep'
                  )
                  let emopjiValScore = val.question_answer_details[0]
                    .st_answer_score
                    ? val.question_answer_details[0].st_answer_score.split('\n')
                    : []
                  if (emojiValues.indexOf(':P') != -1) {
                    tmp.push(':P')
                    if (emopjiValScore[emojiValues.indexOf(':P')]) {
                      tmpScore.push(emopjiValScore[emojiValues.indexOf(':P')])
                    }
                  }
                  if (emojiValues.indexOf(':)') != -1) {
                    tmp.push(':)')
                    if (emopjiValScore[emojiValues.indexOf(':)')]) {
                      tmpScore.push(emopjiValScore[emojiValues.indexOf(':)')])
                    }
                  }
                  if (emojiValues.indexOf(':|') != -1) {
                    tmp.push(':|')
                    if (emopjiValScore[emojiValues.indexOf(':|')]) {
                      tmpScore.push(emopjiValScore[emojiValues.indexOf(':|')])
                    }
                  }
                  if (emojiValues.indexOf(':(') != -1) {
                    tmp.push(':(')
                    if (emopjiValScore[emojiValues.indexOf(':(')]) {
                      tmpScore.push(emopjiValScore[emojiValues.indexOf(':(')])
                    }
                  }
                  if (emojiValues.indexOf(':@') != -1) {
                    tmp.push(':@')
                    if (emopjiValScore[emojiValues.indexOf(':@')]) {
                      tmpScore.push(emopjiValScore[emojiValues.indexOf(':@')])
                    }
                  }
                  console.log(tmp)
                  console.log(tmpScore)
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ]['score'] = tmpScore.join('\n')
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ] = tmp.join('sep')
                } else {
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ] = val.question_answer_details[0].st_answer_text
                }
              } else if (
                val.in_question_validation_id == 16 ||
                val.in_question_validation_id == 17 ||
                val.in_question_validation_id == 40 ||
                val.in_question_validation_id == 41
              ) {
                console.log('in tempLogic 1 else 4 else if')
                // For two choices question type - Yes/No, True/False, Other choices
                if (
                  !state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ]
                ) {
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    'extra'
                  ] = []
                }
                state.surveyQuestionDetails[key].validationDetailsObj[
                  'extra'
                ].push({
                  lat: val.question_answer_details[0].st_latitude
                    ? val.question_answer_details[0].st_latitude
                    : '',
                  lng: val.question_answer_details[0].st_longitude
                    ? val.question_answer_details[0].st_longitude
                    : '',
                  score:
                    items.in_audit == 1 && value.in_audit == 1
                      ? val.question_answer_details[0].st_answer_score
                      : ''
                })
                state.surveyQuestionDetails[key].validationDetailsObj[
                  val.in_question_validation_id
                ] = val.question_answer_details[0].st_answer_text
              } else if (
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_MANDATORY_QUE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SINGLE_LINE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_PARAGRAPH ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SERIAL_NUM ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ALLOW_OTHER_ANS ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SHOW_ANS_LABEL ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SHOW_TITLE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ACCESS_TO_GALLERY ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ADDRESS_QUE
              ) {
                console.log('in tempLogic 1 else 5 else if')
                if (
                  val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS
                ) {
                  state.surveyAllFlagDetails['in_email_sent'].push(
                    value.in_question_master_id
                  )
                }
                console.log(
                  val.in_question_validation_id +
                    'dgg' +
                    val.question_answer_details[0].st_answer_text
                )
                // Check if validation value is set to true or not
                if (val.question_answer_details[0].st_answer_text == 1) {
                  state.surveyQuestionDetails[key].validationDetailsObj[
                    val.in_question_validation_id
                  ] = val.question_answer_details[0].st_answer_text
                }
              } else {
                console.log('in tempLogic 1 else 6 else')
                console.log(
                  val.in_question_validation_id +
                    'dgg1' +
                    val.question_answer_details[0].st_answer_text
                )
                if(value.in_question_type_id == queTypeConfig.TYPE_DATE && val.in_question_validation_id == queValidationConfig.VALIDATION_DATE_FORMAT) {
                  state.surveyAllFlagDetails['in_date_format'][value.in_question_master_id] = val.question_answer_details[0].st_answer_text;
                }
                state.surveyQuestionDetails[key].validationDetailsObj[
                  val.in_question_validation_id
                ] = val.question_answer_details[0].st_answer_text
              }
            }
          }
        })
        console.log('2  key ', key)
      } else {
        // One question at a time
        state.surveyQuestionDetails[key] = {}
        state.surveyQuestionDetails[key]['queDetails'] = value
        state.surveyQuestionDetails[key]['queDetails'][
          'validationDetailsObj'
        ] = {}

        tempValidation.forEach((val, k) => {
          if (val.question_answer_details.length > 0) {
            if (
              val.in_question_validation_id ==
                queValidationConfig.VALIDATION_MANDATORY_QUE &&
              val.question_answer_details[0].st_answer_text == 1 &&
              value.in_question_type_id != queTypeConfig.TYPE_CAMERA &&
              value.in_question_type_id !=
                queTypeConfig.TYPE_QR_AND_BARCODE_READER
            ) {
              totalRequiredQues++
            }
            var patt = '';
            // For allowed characters => Text serial number and number telephone
            if (
              val.in_question_validation_id == queTypeConfig.TYPE_12_HOURS ||
              val.in_question_validation_id ==
                queTypeConfig.TYPE_END_SCREEN_IMAGE
            ) {
              var patt = val.question_answer_details[0].st_regex_value
              try{
                var rx = new RegExp(patt, 'g')
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj[val.in_question_validation_id] = rx
              }catch(err){
                console.log('try catch err', err)
              }

            } else {
              // For terms & Conditions and multiple choices image
              if (
                (value.in_question_type_id ==
                  queTypeConfig.TYPE_MULTIPLE_TEXT &&
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS) ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_TEXT
              ) {
                if (
                  !state.surveyQuestionDetails[key]['queDetails']
                    .validationDetailsObj[val.in_question_validation_id]
                ) {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[val.in_question_validation_id] = []
                }
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj[val.in_question_validation_id].push({
                  answer: val.question_answer_details[0].st_answer_text,
                  lat: val.question_answer_details[0].st_latitude
                    ? val.question_answer_details[0].st_latitude
                    : '',
                  lng: val.question_answer_details[0].st_longitude
                    ? val.question_answer_details[0].st_longitude
                    : '',
                  score:
                    items.in_audit == 1 && value.in_audit == 1
                      ? val.question_answer_details[0].st_answer_score
                      : ''
                })
              } else if (
                val.in_question_validation_id ==
                queValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS
              ) {
                if (
                  !state.surveyQuestionDetails[key]['queDetails']
                    .validationDetailsObj[val.in_question_validation_id]
                ) {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[val.in_question_validation_id] = []
                }
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj[val.in_question_validation_id].push(
                  val.question_answer_details[0].st_answer_text
                )
              } else if (
                (value.in_question_type_id ==
                  queTypeConfig.TYPE_MULTIPLE_IMAGE &&
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS) ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_IMAGE
              ) {
                // st_answer_label
                if (
                  !state.surveyQuestionDetails[key]['queDetails']
                    .validationDetailsObj[val.in_question_validation_id]
                ) {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[val.in_question_validation_id] = []
                }
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj[val.in_question_validation_id].push({
                  score:
                    items.in_audit == 1 && value.in_audit == 1
                      ? val.question_answer_details[0].st_answer_score
                      : '',
                  st_answer_label:
                    val.question_answer_details[0].st_answer_label,
                  dataURL:
                    JSON.parse(val.question_answer_details[0].st_answer_text)
                      .dataURL || '',
                  s3ImagePath:
                    JSON.parse(val.question_answer_details[0].st_answer_text)
                      .s3ImagePath || ''
                })
              } else if (
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SINGLE_LINE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_STAR_RATING ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_FACE_RATING ||
                ((value.in_question_type_id == queTypeConfig.TYPE_LIST || value.in_question_type_id == queTypeConfig.TYPE_DYNAMIC_LIST) &&
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS)
              ) {
                // For List question type - If Allow other answer is ON
                if (
                  val.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOW_OTHER_ANS &&
                  (value.in_question_type_id == queTypeConfig.TYPE_LIST || value.in_question_type_id == queTypeConfig.TYPE_DYNAMIC_LIST)
                ) {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[6] += '\nOther';
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj['extra']['lat'] += val
                    .question_answer_details[0].st_latitude
                    ? '\n' + val.question_answer_details[0].st_latitude
                    : '';
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj['extra']['lng'] += val
                    .question_answer_details[0].st_longitude
                    ? '\n' + val.question_answer_details[0].st_longitude
                    : '';
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj['extra']['score'] +=
                    items.in_audit == 1 && value.in_audit == 1
                      ? '\n' + val.question_answer_details[0].st_answer_score
                      : '';
                } else {
                  // For Text question type - Single line, Rating question type - Satisfaction and Star
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj['extra'] = {
                    lat: val.question_answer_details[0].st_latitude
                      ? val.question_answer_details[0].st_latitude
                      : '',
                    lng: val.question_answer_details[0].st_longitude
                      ? val.question_answer_details[0].st_longitude
                      : '',
                    score:
                      items.in_audit == 1 && value.in_audit == 1
                        ? val.question_answer_details[0].st_answer_score
                        : ''
                  }
                }
                if (
                  val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_FACE_RATING
                ) {
                  // For converting our emoji into BAD to GOOD
                  let emojiValues = val.question_answer_details[0].st_answer_text.split(
                      'sep'
                    ),
                    tmp = []
                  if (emojiValues.indexOf(':P') != -1) tmp.push(':P')
                  if (emojiValues.indexOf(':)') != -1) tmp.push(':)')
                  if (emojiValues.indexOf(':|') != -1) tmp.push(':|')
                  if (emojiValues.indexOf(':(') != -1) tmp.push(':(')
                  if (emojiValues.indexOf(':@') != -1) tmp.push(':@')
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[
                    val.in_question_validation_id
                  ] = tmp.join('sep')
                } else {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[val.in_question_validation_id] =
                    val.question_answer_details[0].st_answer_text
                }
              } else if (
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_YES_NO ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_TRUE_FALSE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_FIRST_CHOICE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SECOND_CHOICE
              ) {
                // For two choices question type - Yes/No, True/False, Other choices
                if (
                  !state.surveyQuestionDetails[key]['queDetails']
                    .validationDetailsObj['extra']
                ) {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj['extra'] = []
                }
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj['extra'].push({
                  lat: val.question_answer_details[0].st_latitude
                    ? val.question_answer_details[0].st_latitude
                    : '',
                  lng: val.question_answer_details[0].st_longitude
                    ? val.question_answer_details[0].st_longitude
                    : '',
                  score:
                    items.in_audit == 1 && value.in_audit == 1
                      ? val.question_answer_details[0].st_answer_score
                      : ''
                })
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj[val.in_question_validation_id] =
                  val.question_answer_details[0].st_answer_text
              } else if (
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_MANDATORY_QUE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SINGLE_LINE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_PARAGRAPH ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SERIAL_NUM ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ALLOW_OTHER_ANS ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SHOW_ANS_LABEL ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_SHOW_TITLE ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ACCESS_TO_GALLERY ||
                val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ADDRESS_QUE
              ) {
                if (
                  val.in_question_validation_id ==
                  queValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS
                ) {
                  state.surveyAllFlagDetails['in_email_sent'].push(
                    value.in_question_master_id
                  )
                }
                if (val.question_answer_details[0].st_answer_text == 1) {
                  state.surveyQuestionDetails[key][
                    'queDetails'
                  ].validationDetailsObj[val.in_question_validation_id] =
                    val.question_answer_details[0].st_answer_text
                }
              } else {
                if(value.in_question_type_id == queTypeConfig.TYPE_DATE && val.in_question_validation_id == queValidationConfig.VALIDATION_DATE_FORMAT) {
                  state.surveyAllFlagDetails['in_date_format'][value.in_question_master_id] = val.question_answer_details[0].st_answer_text;
                }
                state.surveyQuestionDetails[key][
                  'queDetails'
                ].validationDetailsObj[val.in_question_validation_id] =
                  val.question_answer_details[0].st_answer_text
              }
            }
          }
        })
      }

      // [
      //   {
      //     "conditions":{
      //        "rules":[
      //           [
      //              {
      //                 "st_answer_value":"op 1",
      //                 "st_logical_condition":"EQUAL",
      //                 "st_rule_type":"AND"
      //              },
      //              {
      //                 "st_answer_value":"op 2",
      //                 "st_logical_condition":"",
      //                 "st_rule_type":""
      //              }
      //           ],
      //           [
      //              {
      //                 "st_answer_value":"op 3",
      //                 "st_logical_condition":"EQUAL",
      //                 "st_rule_type":""
      //              }
      //           ],
      //           [
      //              {
      //                 "st_answer_value":"op 4",
      //                 "st_logical_condition":"EQUAL",
      //                 "st_rule_type":""
      //              }
      //           ]
      //        ],
      //        "rule_cond":[
      //           "AND",
      //           "OR"
      //        ]
      //     },
      //     "thenQuesNo":4,
      //     "elseQuesNo":3
      //   }
      // ]

      let skipLogicOnprevQuestionId = [] //if skip logic set on previous question insted of on self

      if (tempSkipLogic.length > 0) {
        // console.log(tempSkipLogic);
        var gloablArr = [],
          isAnswered = false
        tempSkipLogic.forEach((val, k) => {
          // console.log(val.skip_logic_rule);
          // If any rule is available for question or not
          if (val.skip_logic_rule.length > 0) {
            var tempSkipLogicRule = val.skip_logic_rule
            // delete val.skip_logic_rule
            var tempRules = [],
              tempRulesCond = [],
              tempIsAnswered = []
            tempSkipLogicRule.forEach((v, k) => {
              var tempSkipLogicRuleDetails = v.skip_logic_rule_details
              // delete val.skip_logic_rule_details
              var tempConditionObject = [],
                allAnswerArr = []
              tempSkipLogicRuleDetails.forEach((v1, k1) => {
                allAnswerArr.push(
                  v1.st_answer_value.replace(' (Not from list)', '')
                )
                tempConditionObject.push({
                  st_answer_value: v1.st_answer_value.replace(
                    ' (Not from list)',
                    ''
                  ),
                  st_logical_condition: v1.st_logical_condition,
                  st_rule_type: v1.st_rule_type,
                  in_question_master_id: v1.in_question_master_id,
                  all_answer_arr: allAnswerArr
                })
                if(val.in_parent_question_id != v1.in_question_master_id){
                    if(skipLogicOnprevQuestionId.indexOf(v1.in_question_master_id) === -1){
                        skipLogicOnprevQuestionId.push(v1.in_question_master_id)
                    }
                }
              })
              if (v.st_skiplogic_condition && v.st_skiplogic_condition != '') {
                tempRulesCond.push(v.st_skiplogic_condition)
              }
              if (v.st_is_answer && v.st_is_answer != '') {
                tempIsAnswered.push(v.st_is_answer)
              }
              tempRules.push({
                in_question_type_id: v.in_question_type_id,
                details: tempConditionObject
              })
              // state.surveyQuestionDetails[key]['skipLogic'] = [
              //   {
              //     conditions: {
              //       "rules": tempRules,
              //       "rule_cond": tempRulesCond,
              //       "is_answered": tempIsAnswered
              //     },
              //     thenQuesNo: parseInt(val.in_then_question_number),
              //     elseQuesNo: parseInt(val.in_else_question_number),
              //   }
              // ];
              state.surveyQuestionDetails[key]['groupNo'] = groupNo
              if (v.st_is_answer === 'ANSWERED') {
                isAnswered = true
              } else {
                state.surveyQuestionDetails[key]['displayFlag'] = displayFlag
              }
            })
            gloablArr.push({
              conditions: {
                rules: tempRules,
                rule_cond: tempRulesCond,
                is_answered: tempIsAnswered
              },
              thenQuesNo: parseInt(val.in_then_question_number),
              elseQuesNo:
                val.in_max_else_question_number &&
                val.in_max_else_question_number != ''
//                  ? parseInt(val.in_max_else_question_number)
                  ? parseInt(val.in_else_question_number)
                  : parseInt(val.in_else_question_number)
            })
          }
          // if(val.skip_logic_rule.length > 0) {
          //   var tempConditionObject = {};
          //   var tempSkipLogicAsoc = val.skip_logic_rule_assoc_details;
          //   delete val.skip_logic_rule_assoc_details;
          //   tempSkipLogicAsoc.forEach((v, k) => {
          //     tempConditionObject[v.in_question_master_id] = v.st_condition;
          //   });
          //   state.surveyQuestionDetails[key]['skipLogic'] = [
          //     {
          //       conditions: tempConditionObject,
          //       goto: parseInt(val.st_next_question)
          //     }
          //   ]
          // }
        })
        // state.surveyQuestionDetails[key]['groupNo'] = groupNo;
        // groupNo = groupNo + 1;
        // if(isExecuteDisplayFlag) {
        //   displayFlag = 1;
        //   state.surveyQuestionDetails[key]['displayFlag'] = displayFlag;
        //   displayFlag = 0;
        // } else {
        //   state.surveyQuestionDetails[key]['displayFlag'] = displayFlag;
        // }
        console.log(isAnswered)
        // if(isAnswered) {
        groupNo = groupNo + 1

        if (isExecuteDisplayFlag) {
          displayFlag = 1
          state.surveyQuestionDetails[key]['displayFlag'] = displayFlag
          displayFlag = 0
        } else {
          state.surveyQuestionDetails[key]['displayFlag'] = displayFlag
        }
        // }
        state.surveyQuestionDetails[key]['skipLogic'] = gloablArr
        isExecuteDisplayFlag = false
      } else {
        state.surveyQuestionDetails[key]['groupNo'] = groupNo
        state.surveyQuestionDetails[key]['displayFlag'] = displayFlag
        state.surveyQuestionDetails[key]['skipLogic'] = []
        // displayFlag = 0;
      }
      state.surveyQuestionDetails[key]['skipLogicOf'] = [] //check if this question is depended on any questions from next questions list
      state.surveyQuestionDetails[key]['in_question_master_id'] = value.in_question_master_id
      if(skipLogicOnprevQuestionId.length > 0){
          skipLogicOnprevQuestionId.forEach((value)=> {
              let prevQueIdx = questionIds.indexOf(value)
              if(prevQueIdx !== -1){
                  state.surveyQuestionDetails[prevQueIdx]['skipLogicOf'].push(key)
              }
          })
      }
//      console.log('skipLogicOnprevQuestionId',skipLogicOnprevQuestionId)
      console.log('item key', key)
    })
    console.log('after foreach items["survey_question_detail"]')
    state.surveyMasterDetails = {
      st_survey_name: items.st_survey_name,
      in_question_flow: items.in_question_flow,
      in_total_required_ques: totalRequiredQues,
      in_loop_survey: items.in_loop_survey,
      in_audit: items.in_audit,
      in_status: items.in_status
    }
    console.log('state.surveyMasterDetails after set', state.surveyMasterDetails)
    state.surveyQuestionDetails.forEach((skipVal, skipKey) => {
      if (skipVal.skipLogic.length > 0 && skipVal.displayFlag == 1) {
        let largest = 1
        for (let k = 0; k < skipVal.skipLogic.length; k++) {
          if (
            skipVal.skipLogic[k].conditions.is_answered.includes('NOTANSWERED')
          ) {
            for (
              let i = skipKey + 1;
              i < state.surveyQuestionDetails.length;
              i++
            ) {
              if (
                state.surveyQuestionDetails[i].groupNo ==
                skipVal.groupNo + 1
              ) {
                if (skipVal.skipLogic[k].thenQuesNo > largest) {
                  largest = skipVal.skipLogic[k].thenQuesNo - 1
                }
                let disVal = i < largest ? 0 : 1
                state.surveyQuestionDetails[i].displayFlag = disVal
              }
            }
          }
        }
      }
    })
    console.log('===== validation Details Array =====')
    console.log(state.surveyQuestionDetails)
    // if (typeof (items.survey_design_details.st_survey_design_data) === 'string') {
    //   var item = JSON.parse(items.survey_design_details.st_survey_design_data)
    //   state.surveyDesignDetails = item
    // } else {
    //   state.surveyDesignDetails = items.survey_design_details.st_survey_design_data
    // }
  },
  setSurveyOriginalQuestionDetails(state, items){
    console.log('setSurveyOriginalQuestionDetails', items)
    state.surveyOriginalQuestionDetails = items
  },
  setAllDesign (state, items) {
    state.surveyDesignDetails = normalizeSurveyDesignDetails(items)
  },
  setsurveyStartEndQuestions (state, items) {
    if (items.length > 0) {
      if (items[0]) {
        items[0]['in_question_type_id'] === queTypeConfig.TYPE_START_SCREEN_TEXT
          ? (state.surveyStartEndQuestions['start'] = items[0])
          : (state.surveyStartEndQuestions['end'] = items[0])
      }
      if (items[1]) {
        items[1]['in_question_type_id'] === queTypeConfig.TYPE_START_SCREEN_TEXT
          ? (state.surveyStartEndQuestions['start'] = items[1])
          : (state.surveyStartEndQuestions['end'] = items[1])
      }

      // FOR START SCREEN
      if (
        (items[0] &&
          items[0]['question_type_details']['control_details'][
            'in_control_id'
          ] == 17) ||
        (items[1] &&
          items[1]['question_type_details']['control_details'][
            'in_control_id'
          ] == 17)
      ) {
        let tempPreviewValidation = {}
        if (
          items[0]['question_type_details']['control_details'][
            'in_control_id'
          ] == 17
        ) {
          tempPreviewValidation = items[0]['question_validation_details']
          delete items[0]['question_validation_details']
        } else {
          tempPreviewValidation = items[1]['question_validation_details']
          delete items[1]['question_validation_details']
        }
        state.surveyStartEndQuestions['start']['validationDetailsObj'] = {}
        tempPreviewValidation.forEach((val, k) => {
          if (val.question_answer_details.length > 0) {
            state.surveyStartEndQuestions['start'].validationDetailsObj[
              val.in_question_validation_id
            ] = val.question_answer_details[0].st_answer_text
          }
        })
      }

      if (
        (items[0] &&
          items[0]['question_type_details']['control_details'][
            'in_control_id'
          ] == 18) ||
        (items[1] &&
          items[1]['question_type_details']['control_details'][
            'in_control_id'
          ] == 18)
      ) {
        let tempPreviewValidation = {}
        if (
          items[0]['question_type_details']['control_details'][
            'in_control_id'
          ] == 18
        ) {
          tempPreviewValidation = items[0]['question_validation_details']
          delete items[0]['question_validation_details']
        } else {
          tempPreviewValidation = items[1]['question_validation_details']
          delete items[1]['question_validation_details']
        }
        state.surveyStartEndQuestions['end']['validationDetailsObj'] = {}
        tempPreviewValidation.forEach((val, k) => {
          if (val.question_answer_details.length > 0) {
            state.surveyStartEndQuestions['end'].validationDetailsObj[
              val.in_question_validation_id
            ] = val.question_answer_details[0].st_answer_text
          }
        })
      }
    }

    console.log('==== FINAL DATA === ')
    console.log(state.surveyStartEndQuestions)
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setQuery (state, query) {
    state.query = query
  },
  setCancelSource (state) {
    state.cancelSource = axios.CancelToken.source()
  },
  resetState (state) {
    state = Object.assign(state, initialState())
  },
  setAddResponseStatus (state, items) {
    state.addResponseStatus = items
  },
  setEditResponseStatus (state, items) {
    state.editResponseStatus = items
  },
  setSurveyResponseDetails (state, items) {
    state.surveyDateDetails = items['data'];
    var dateformat = "";
    switch (items['timezone']['st_datetime_format']) {
      case 'd/m/Y H:i:s':
        dateformat = "DD/MM/YYYY hh:mm:ss";
        break;
      case 'Y/m/d H:i:s':
        dateformat = "YYYY/MM/DD hh:mm:ss";
        break;
      case 'm/d/Y H:i:s':
        dateformat = "MM/DD/YYYY hh:mm:ss";
        break;
      default:
        dateformat = "YYYY-MM-DD hh:mm:ss";
        break;
    }
    var UTC_date_collected    = moment.tz(state.surveyDateDetails.dt_date_collected, "UTC");
    state.surveyResponseDate['dt_date_collected'] = UTC_date_collected.clone().tz(items['timezone']['st_timezone']).format(dateformat);

    var UTC_date_sent    = moment.tz(state.surveyDateDetails.dt_date_sent, "UTC");
    state.surveyResponseDate['dt_date_sent'] = UTC_date_sent.clone().tz(items['timezone']['st_timezone']).format(dateformat);

    var UTC_date_recieved    = moment.tz(state.surveyDateDetails.dt_added_at, "UTC");
    state.surveyResponseDate['dt_added_at'] = UTC_date_recieved.clone().tz(items['timezone']['st_timezone']).format(dateformat);
    state.surveyResponseDate['st_user_name'] = state.surveyDateDetails.st_user_name;
    var in_latitude = parseFloat(state.surveyDateDetails.st_latitude);
    var in_longitude = parseFloat(state.surveyDateDetails.st_longitude);
    var latitude    = (in_latitude == 0) ? in_latitude.toFixed(1) : in_latitude;
    var longitude   = (in_longitude == 0) ? in_longitude.toFixed(1) : in_longitude;
    var GPS = latitude+ "," + longitude;
    state.surveyResponseDate['gps_location'] = GPS;

    var surveyResponseData = items['data']['survey_response_details'];
    console.log("surveyResponseData", surveyResponseData);
    var surveyResponsesData = {};
    var oldResponseAnswerData = {};
    var surveyResponseDetailIdsData = {};
    var chkOtherMultChoice = {};
    var defautchkMapMulChoiceQuestion = {};
    var setDefaultTime = {};
    try {
    for (let index = 0; index < surveyResponseData.length; index++) {
      var listQuestions = [];
      var keyIndex = surveyResponseData[index]['in_question_master_id'];
      if(state.surveyMasterDetails.in_question_flow == 0) {
        state.surveyQuestionDetails.map((skipVal, keyIndex) =>  {
            state.surveyQuestionDetails[keyIndex]['validationDetailsObj']  = state.surveyQuestionDetails[keyIndex].queDetails.validationDetailsObj
        })
      }
      surveyResponseDetailIdsData[keyIndex] = surveyResponseData[index]['in_response_detail_id'];
      oldResponseAnswerData[keyIndex] = surveyResponseData[index]['st_answer'];
      switch (surveyResponseData[index]['in_question_type_id']) {
        case queTypeConfig.TYPE_LIST: //list question(3)
        case queTypeConfig.TYPE_DYNAMIC_LIST: //dynamic list question(29)
          var splitAuditList = surveyResponseData[index]['st_answer'].split(" (Score");
          var validationArrIndex = state.surveyQuestionDetails.findIndex(
            x => x.in_question_master_id == keyIndex
          );
          listQuestions = state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['6'].split('\n');//7
          if (listQuestions.indexOf(splitAuditList[0]) != -1 && splitAuditList[0] != 'Other') {
            state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = false;
            surveyResponsesData[keyIndex] = { 'formatted_address': splitAuditList[0], 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] }
          }
          else {
            chkOtherMultChoice[keyIndex] = { 'formatted_address': splitAuditList[0], 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] };
            state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = true;
            surveyResponsesData[keyIndex] = { 'formatted_address': 'Other', 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] }
          }
          break;
        case queTypeConfig.TYPE_YES_NO: //Two Choice(4)
        case queTypeConfig.TYPE_TRUE_FALSE:
          if(surveyResponseData[index]['st_answer'] != "")
          {
            var splitAuditTwoChoice = surveyResponseData[index]['st_answer'].split(" (Score");
            var answerValue = splitAuditTwoChoice[0].toLowerCase(); // this value is always store in lowecase from online, but from mobile it's store as capital so need to convert into lower case
            surveyResponsesData[keyIndex] = { 'value': answerValue, 'score': surveyResponseData[index]['in_score'] }
            state.tempPreviouslySelectedRating[keyIndex] = answerValue;
          }
          break;
        case queTypeConfig.TYPE_OTHER:
          if(surveyResponseData[index]['st_answer'] != "")
          {
            var splitAuditTwoChoice = surveyResponseData[index]['st_answer'].split(" (Score");
            surveyResponsesData[keyIndex] = { 'value': splitAuditTwoChoice[0], 'score': surveyResponseData[index]['in_score'] }
            state.tempPreviouslySelectedRating[keyIndex] = splitAuditTwoChoice[0];
          }
          break;
        case queTypeConfig.TYPE_MULTIPLE_TEXT: //Multi Choice Question(5) - Text Question
          if(surveyResponseData[index]['st_answer'] != "")
          {
            var splitAuditMultiple = surveyResponseData[index]['st_answer'].split(" (Score");
            var mulchoiceAnswer = JSON.parse(splitAuditMultiple[0]);
            var validationArrIndex = state.surveyQuestionDetails.findIndex(
              x => x.in_question_master_id == keyIndex
            );
            var textValue = state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['14'];
            var arrOtherAnswer = textValue && textValue.length > 0 && textValue.map(x => {
              return x.answer;
            });
            var found = true;
            if(arrOtherAnswer){
              found = arrOtherAnswer.some(r=> mulchoiceAnswer.includes(r));
            }
            var multipleChoiceNormalAnswer = [];
            var multipleChoiceOtherAnswer = [];
            var multipleChoiceArray = [];
            if(!state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['20']) // Allow more then answer is disabled
            {
              multipleChoiceNormalAnswer = { 'formatted_address': mulchoiceAnswer[0], 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] };
              if(state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['13'] && !found)
              {
                chkOtherMultChoice[keyIndex] = multipleChoiceNormalAnswer;
                surveyResponsesData[keyIndex] = 'Other';
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = true;
                state.tempPreviouslySelectedRating[keyIndex] = 'Other';
              }else{
                defautchkMapMulChoiceQuestion[keyIndex] = multipleChoiceNormalAnswer //chkMapMulChoice
                surveyResponsesData[keyIndex] = mulchoiceAnswer[0] //chkSurveyQuestionDetails
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = false;
                state.tempPreviouslySelectedRating[keyIndex] = mulchoiceAnswer[0];
              }
            }
            else
            {
              for (let index = 0; index < mulchoiceAnswer.length; index++) {
                const elementValue = mulchoiceAnswer[index];

                if(arrOtherAnswer.includes(elementValue)) {
                  multipleChoiceNormalAnswer.push({ 'formatted_address': elementValue, 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] });
                  multipleChoiceArray.push(elementValue); 
                } else {
                  multipleChoiceOtherAnswer = { 'formatted_address': elementValue, 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] };
                  multipleChoiceArray.push('Other');
                }
              }
              surveyResponsesData[keyIndex] = multipleChoiceArray; //chkSurveyQuestionDetails
              state.tempPreviouslySelectedRating[keyIndex] = multipleChoiceArray;
              if(state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['13'] && multipleChoiceArray.includes('Other'))
              {
                chkOtherMultChoice[keyIndex] = multipleChoiceOtherAnswer; //chkOtherMulChoice
                defautchkMapMulChoiceQuestion[keyIndex] = multipleChoiceNormalAnswer;
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = true;
              }else{
                defautchkMapMulChoiceQuestion[keyIndex] = multipleChoiceNormalAnswer; //chkMapMulChoice
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = false;
              }
            }
          }
          break;
        case queTypeConfig.TYPE_MULTIPLE_IMAGE: //Multi Choice Question(13) - Image Question
          var multipleChoiceNormalImageAnswer = [];
          var multipleChoiceImageArray = [];
          var multipleChoiceOtherImageAnswer = [];
          var validationArrIndex = state.surveyQuestionDetails.findIndex(
            x => x.in_question_master_id == keyIndex
          );

          if(surveyResponseData[index]['st_answer'] != "")
          {
            var answerVal = JSON.parse(surveyResponseData[index]['st_answer']);
            var textValue = state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['15'];
            var arrOtherAnswer = textValue && textValue.length > 0 && textValue.map(x => {
              return x.s3ImagePath;
            });
            var found = true;
            if(arrOtherAnswer){
              found = arrOtherAnswer.some(r=> answerVal.includes(r));
            }
            if(!state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['20']) // Allow more then answer is disabled
            {
              multipleChoiceNormalImageAnswer = { 'formatted_address': answerVal[0], 'lat': surveyResponseData[index]['st_latitude'] ? surveyResponseData[index]['st_latitude'] : '', 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] };
              if(state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['13'] && !arrOtherAnswer.some(r=> answerVal.includes(r)))
              {
                chkOtherMultChoice[keyIndex] = multipleChoiceNormalImageAnswer;
                surveyResponsesData[keyIndex] = 'Other';
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = true;
                state.tempPreviouslySelectedRating[keyIndex] = 'Other';
              }else{
                defautchkMapMulChoiceQuestion[keyIndex] = multipleChoiceNormalImageAnswer //chkMapMulChoice
                surveyResponsesData[keyIndex] = answerVal[0] //chkSurveyQuestionDetails
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = false;
                state.tempPreviouslySelectedRating[keyIndex] = answerVal[0];
              }
            }
            else
            {
              for (let index = 0; index < answerVal.length; index++) {
                const elementValue = answerVal[index];

                if(arrOtherAnswer.includes(elementValue)) {
                  multipleChoiceNormalImageAnswer.push({ 'formatted_address': elementValue, 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] });
                  multipleChoiceImageArray.push(elementValue);
                } else {
                  multipleChoiceOtherImageAnswer = { 'formatted_address': elementValue, 'lat': surveyResponseData[index]['st_latitude'], 'lng': surveyResponseData[index]['st_longitude'], 'score': surveyResponseData[index]['in_score'] };
                  multipleChoiceImageArray.push('Other');
                }
              }
              surveyResponsesData[keyIndex] = multipleChoiceImageArray; //chkSurveyQuestionDetails
              state.tempPreviouslySelectedRating[keyIndex] = multipleChoiceImageArray;
              defautchkMapMulChoiceQuestion[keyIndex] = multipleChoiceNormalImageAnswer; //chkMapMulChoice

              if(state.surveyQuestionDetails[validationArrIndex]['validationDetailsObj']['13'] && multipleChoiceImageArray.includes('Other'))
              {
                chkOtherMultChoice[keyIndex] = multipleChoiceOtherImageAnswer; //chkOtherMulChoice
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = true;
              }else{
                state.surveyQuestionDetails[validationArrIndex]["queDetails"]['other'] = false;
              }

            }
          }
          break;
        case queTypeConfig.TYPE_12_HOURS:  //time question
        case queTypeConfig.TYPE_24_HOURS:
          if(surveyResponseData[index]['st_answer'] != "")
          {
            surveyResponsesData[keyIndex] = moment(surveyResponseData[index]['st_answer'], "hh:mm:ss a").format("HH:mm:ss");
            setDefaultTime[keyIndex] = surveyResponseData[index]['st_answer'];
          }else{
            surveyResponsesData[keyIndex] = moment().format('HH:mm:ss');
            setDefaultTime[keyIndex] = "";
          }
          break;
        case queTypeConfig.TYPE_SATISFACTION:
          if(surveyResponseData[index]['st_answer'] != "")
          {
            var splitAuditSatisfation = surveyResponseData[index]['st_answer'].split(" (Score");
            state.tempPreviouslySelectedRating[keyIndex] = splitAuditSatisfation[0];
            surveyResponsesData[keyIndex] = { 'value': splitAuditSatisfation[0], 'score': surveyResponseData[index]['in_score'] }
          }
          break;
        case queTypeConfig.TYPE_STAR:
          if(surveyResponseData[index]['st_answer'] != "")
          {
            var splitAuditStar = surveyResponseData[index]['st_answer'].split(" (Score");
            surveyResponsesData[keyIndex] = { 'value': splitAuditStar[0], 'score': surveyResponseData[index]['in_score']}
          }
          break;
        case queTypeConfig.TYPE_DATE:
          var quesType = state.surveyQuestionDetails.find(
            x => x.queDetails.in_question_master_id == keyIndex
          );
          if(surveyResponseData[index]['st_answer'] != "")
          {
            var dateFormat = quesType.validationDetailsObj[42] ? quesType.validationDetailsObj[42] : "DD-MM-YYYY";
            var stAnswer = moment(surveyResponseData[index]['st_answer'], "MM/DD/YYYY").format(dateFormat);
            surveyResponsesData[keyIndex] = stAnswer;
          }
          break;
        case queTypeConfig.TYPE_CAMERA: //Photo Question
          surveyResponsesData[keyIndex] = surveyResponseData[index]['s3DataURL'];
          state.storeAllPhotoQuestion[keyIndex] = surveyResponseData[index]['s3DataURL'];
          state.showAllPhotoQuestion[keyIndex] = true;
          break;
        case queTypeConfig.TYPE_SIGNATURE:
          state.showAllSignatureQuestion[keyIndex] = false;
          if(surveyResponseData[index]['s3DataURL'])
          {
            state.signatureQuestionsDetails[keyIndex] = surveyResponseData[index]['s3DataURL'];
            surveyResponsesData[keyIndex] = surveyResponseData[index]['s3DataURL'];
            state.showAllSignatureQuestion[keyIndex] = true;
          }
          break;
        case queTypeConfig.TYPE_INPUT:
        case queTypeConfig.TYPE_NUMBER:
        case queTypeConfig.TYPE_TELEPHONE:
        case queTypeConfig.TYPE_CURRENCY:
        case queTypeConfig.TYPE_DISPLAY:
        case queTypeConfig.TYPE_TERMS_AND_CONDITIONS:
          surveyResponsesData[keyIndex] = surveyResponseData[index]['st_answer'];
          if(surveyResponseData[index]['in_address'] == 1)
          {
            surveyResponsesData[keyIndex] = { "lat": surveyResponseData[index]['st_latitude'], "lng": surveyResponseData[index]['st_longitude'], "formatted_address": surveyResponseData[index]['st_answer'], "score": surveyResponseData[index]['in_score'] }
            state.allAddressQuestions[keyIndex] = surveyResponseData[index]['st_answer'];
          }
          break;
        case queTypeConfig.TYPE_EMAIL:
          surveyResponsesData[keyIndex] = surveyResponseData[index]['st_answer'];
          break;
        case queTypeConfig.TYPE_IMAGE:
          surveyResponsesData[keyIndex] = JSON.parse(surveyResponseData[index]['st_imagepath']);
          break;  
        default:
          surveyResponsesData[keyIndex] = surveyResponseData[index]['st_answer'];
          break;
      }
    }

  } catch (error) {
      console.log("Innnnnnnnnnnnnnnnnnnnnn");
      console.log(error);
  }
    state.defautchkMapMulChoice = defautchkMapMulChoiceQuestion;
    state.chkOtherMultipleChoice = chkOtherMultChoice;
    state.surveyResponseDetails = surveyResponsesData;
    state.oldResponseAnswer = oldResponseAnswerData;
    state.surveyResponseDetailIds = surveyResponseDetailIdsData;
    state.defautSetTime = setDefaultTime;
  },
  setAllSurveyAnswersDetails(state, items) {
    var surveyQuestionData = {};
    for (let index = 0; index < items.length; index++) {
      if(!surveyQuestionData[items[index]['in_question_master_id']]){
        surveyQuestionData[items[index]['in_question_master_id']] = [];
      }
      surveyQuestionData[items[index]['in_question_master_id']].push(items[index]['st_answer'])
    }
    state.allSurveyAnswersDetails = surveyQuestionData;
  },
  setSearchResponseStatus (state, items) {
    if(items.data)
    {
      if(items['timezone'])
      {
        var dateformat = "";
        switch (items['timezone']['st_datetime_format']) {
          case 'd/m/Y H:i:s':
            dateformat = "DD/MM/YYYY HH:mm:ss";
            break;
          case 'Y/m/d H:i:s':
            dateformat = "YYYY/MM/DD HH:mm:ss";
            break;
          case 'm/d/Y H:i:s':
            dateformat = "MM/DD/YYYY HH:mm:ss";
            break;
          default:
            dateformat = "YYYY-MM-DD HH:mm:ss";
            break;
        }
        var UTC_date_collected    = moment.tz(items.data.dt_date_collected, "UTC");
        var dt_date_collected = UTC_date_collected.clone().tz(items['timezone']['st_timezone']).format(dateformat);
        items.data.dt_date_collected = dt_date_collected;
      }
      else
      {
        items.data.dt_date_collected = items.data.dt_date_collected;
      }
    }
    state.searchResponse = items;
  },
}
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}
